import React from "react"
import { MobileView, browserName, browserVersion } from "react-device-detect"

export function WarningMessage({ title, message }) {
  return (
    <React.Fragment>
      <div>
        <strong>{title}</strong> <span>{message}</span>
      </div>
    </React.Fragment>
  )
}

export function CompatibilityWarning() {
  return (
    <WarningMessage
      title={`Your web browser (${browserName} ${browserVersion}) is out of date.`}
      message={
        <React.Fragment>
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.softpedia.com/get/Internet/Browsers/"
            >
              Update your browser
            </a>{" "}
            for more security, speed and the best experience on this site.
          </span>
        </React.Fragment>
      }
    />
  )
}

export function OptimizationWarning() {
  return (
    <MobileView>
      <WarningMessage
        title="It looks like this page is not mobile optimized."
        message="For best experience please open this page on your PC."
      />
    </MobileView>
  )
}
